export default {
  'Submit': 'Indienen',
  'Save': 'Opslaan',
  'enterOTP': 'Bevestig uw telefoonnummer',
  'otpSent': 'Eenmalig wachtwoord verstuurd',
  'login/signup': 'Inloggen / Aanmelden',
  'resendCode': 'Code opnieuw verzenden',
  'edit': 'Aanpassen',
  'otpMessage': 'Er is een 6-cijferige code naar uw mobiele nummer verzonden',
  'oyo360WelcomeMessage': 'Welkom bij OYO',
  'oyo360ResendCode': 'Code opnieuw verzenden',
  'oyo360Edit': 'Wijzigen',
  'oyo360otpMessage': 'Voer de code in die we hebben verzonden via sms naar uw mobiele nummer',
  'buttonActionContinue': 'Doorgaan',
  'chooseLanguage': 'Selecteer een taal',
  'currentLanguage': 'HUIDIGE TAAL',
  'otherLanguages': 'ANDERE TALEN',
  'google': 'Aanmelden via Google',
  'facebook': 'Aanmelden via Facebook',
  'or': 'of',
  'buttonActionSubmit': 'Bevestigen',
  'welcomeTitle': 'Welkom bij OYO',
  'welcomeHeadingForMailLogin': 'Vul het bij ons bekende e-mailadres in',
  'welcomeHeadingForPhoneLogin': 'Vul het bij ons bekende mobiele telefoonnummer in',
  'emailIdLabel': 'E-mailadres',
  'phoneNumberLabel': 'Telefoonnummer',
  'passwordLabel': 'Wachtwoord',
  'newPasswordLabel': 'Nieuw wachtwoord',
  'confirmNewPasswordLabel': 'Nieuw wachtwoord bevestigen',
  'emailErrorMessage': 'Vul het juiste e-mailadres in',
  'phoneNumberErrorMessage': 'Vul het juiste telefoonnummer in',
  'passwordErrorMessage': 'Vul het juiste wachtwoord in',
  'confirmPasswordErrorMessage': 'Wachtwoord kom niet overeen!',
  'generateNewPassword': 'Maak een nieuw wachtwoord aan',
  'loginButtonLabel': 'Inloggen',
  'loginWithPhoneButtonLabel': 'Doorgaan met telefoon',
  'loginWithOtp': 'Inloggen met een tijdelijk wachtwoord',
  'loginWithEmailButtonLabel': 'Doorgaan met e-mailadres',
  'back': 'Terug',
  'loginWithOtpTitle': 'Verificatiecode invullen',
  'loginWithOtpHeading': 'Er is een 6-cijferige code naar uw mobiele nummer verzonden',
  'listYourProperty': 'Vermeld uw accommodatie',
  'privacyPolicy': 'Privacybeleid',
  'verifyEmail': 'E-mailadres verifiëren',
  'verifyMobile': 'Mobiel nummer verifiëren',
  'forgotPasswordPhoneSubHeading': 'We sturen u een 6-cijferige code om uw telefoonnummer te verifiëren',
  'forgotPasswordMailSubHeading': 'We sturen u een 6-cijferige code om uw e-mailadres te verifiëren',
  'newPasswordCondition1': 'Moet zowel een getal als een leesteken bevatten',
  'newPasswordCondition2': 'Moet uit minstens 8 tekens bestaan',
  'newPasswordCondition3': 'Moet zowel hoofdletters als kleine letters bevatten',
  'confirmLogin': 'Bevestigen en inloggen',
  'getOTP': 'Tijdelijk wachtwoord aanvragen',
  'invalidInput': 'Ongeldige invoer',
  'passwordResetMessage': 'Wachtwoord met succes gegenereerd',
  'otpErrorMessage': 'Vul het juiste tijdelijke wachtwoord in',
  'resendOtpSuccessMessage': 'Er is nogmaals een tijdelijk wachtwoord naar uw mobilie nummer verzonden',
  'InternalServerErrorMessage': 'Interne server fout',
  'resetPasswordHeading': 'Er is een 6-cijferige code naar uw e-mailadres en mobiele nummer verzonden',
  'signingIn': 'Inloggen',
  'invalidMobileNumber': 'Ongeldig mobiel nummer',
  'privacyFooterText': 'Door in te loggen op het account, gaat u akkoord met onze {termsOfUse} en {privacyPolicy}',
  'and': 'en',
  'termsOfUse': 'Gebruiksvoorwaarden ',
  'listProperty': 'Vermeld accommodatie',
  'whiteSpace': ' ',
  'facingIssue': 'Facing any issue? ',
  'oldLoginViewSwitch': 'Switch to Old view',
  'mobileNumberPlaceholder': 'Telefoonnummer invoeren',
  'loginSubText': 'Vul uw telefoonnummer in om in slechts 30 minuten een vakantiehuis van Belvilla te worden',
  'termsOfService': 'Servicevoorwaarden',
  'termsOfServiceFooter': 'Door hieronder Doorgaan te selecteren, ga ik akkoord met de volgende {termsOfService}',
  'secureInformation': 'Geen zorgen, uw gegevens zijn veilig bij ons',
  'mobileSearchPlaceholder': 'Zoekopdracht',
  'passwordChangeInformationText': 'Na het wijzigen van je wachtwoord word je automatisch uitgelogd van alle apparaten'
};
